import React, { Fragment } from 'react';
import ConcessionaireDetail from './ConcessionaireDetail';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';

const ViewConcessionaire = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle='View Concessionaire' parent='Concessionaire' title='Concessionaire Detail' />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <ConcessionaireDetail />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default ViewConcessionaire